import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TProductState = {
  data: [];
  perPage: number;
  currentPage: number;
  totalPage: number;
  searchTerm: string;
  loading: boolean;
  sortBy: string;
  sortColumn: string;
  rerender1: boolean;
   totalCount: number
};

const initialProductState: TProductState = {
  data: [],
  perPage: 10,
  currentPage: 1,
  totalPage: 1,
  searchTerm: "",
  loading: false,
  sortBy: "desc",
  sortColumn: "",
  rerender1: false,
  totalCount: 0
};

export const productSlice = createSlice({
  name: "product",
  initialState: initialProductState,
  reducers: {
    setProduct: (state: TProductState, { payload }: PayloadAction<[]>) => {
      state.data = payload;
    },
    setPerPage: (state: TProductState, { payload }: PayloadAction<number>) => {
      state.perPage = payload;
    },
    setTotalCount: (state:TProductState, {payload}: PayloadAction<number>) => {
                    state.totalCount = payload;
    },
    setCurrentPage: (
      state: TProductState,
      { payload }: PayloadAction<number>
    ) => {
      state.currentPage = payload;
    },
    setTotalPage: (
      state: TProductState,
      { payload }: PayloadAction<number>
    ) => {
      state.totalPage = payload;
    },
    setSearchTerm: (
      state: TProductState,
      { payload }: PayloadAction<string>
    ) => {
      state.searchTerm = payload;
    },
    setSortBy: (state: TProductState, { payload }: PayloadAction<string>) => {
      state.sortBy = payload;
    },
    setSortColumn: (
      state: TProductState,
      { payload }: PayloadAction<string>
    ) => {
      state.sortColumn = payload;
      state.sortBy = "desc";
    },
    setLoading: (state: TProductState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setRerender: (
      state: TProductState,
      { payload }: PayloadAction<boolean>
    ) => {
      state.rerender1 = payload;
    },
  },
});

export const {
  setProduct,
  setPerPage,
  setCurrentPage,
  setSortColumn,
  setSortBy,
  setTotalPage,
  setSearchTerm,
  setLoading,
  setRerender,
  setTotalCount
} = productSlice.actions;
export default productSlice.reducer;
